import * as MediaFormats from 'Media/MediaFormats';
import { getResource } from 'Misc/network';
import { vastToConfig } from 'Misc/parsers';

export default class VASTParser {
  constructor(resource) {
    this.resource = resource;
  }

  async toConfig() {
    try {
      if(!this.xmlString) {
        this.xmlString = await getResource(this.resource);
      }
      return vastToConfig(this.xmlString);
    } catch(e) {
      throw new Error(`error parsing ${this.resource}. ${e.toString()}`);
    }
  }
}


// WEBPACK FOOTER //
// ./src/Services/Parsers/VASTParser.js